interface RadioButtonProps {
  options: string[];
  onChange: (value: string) => void;
  value: string;
  className?: string;
}

export default function RadioButton ({ options, onChange, value, className = "" }: RadioButtonProps) {

  const handleChange = (optionValue: string) => {
    onChange(optionValue);
  };

  return (
    <div className={`flex ${className}`}>
      {options.map((option, index) => (
        <label key={index} className="flex items-center space-x-2">
          <input
            type="radio"
            value={option}
            checked={value === option}
            onChange={() => handleChange(option)}
            className="hidden"
          />
          <span
            className={`w-6 h-6 my-[5px] rounded-md flex items-center border border-gray-300 justify-center cursor-pointer ${
              value === option
                ? "bg-white border-primaryVar"
                : "bg-white border-gray-300"
            }`}
          >
            {value === option && (
              <span className="w-[14px] h-[14px] bg-primaryVar rounded " />
            )}
          </span>
          <span className="text-sm font-normal text-gray-600 my-0.5">
            {option}
          </span>
        </label>
      ))}
    </div>
  );
};